if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");
	linkTag.setAttribute("data-vanilla-extract", "true");

	linkTag.rel = "stylesheet";
	linkTag.type="text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}

	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = "anonymous";
}
	if (oldTag) {
  oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
} else {
  document.head.appendChild(linkTag);
}
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"3808": 0,

};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {
"8370": 1,
"8900": 1,
"8517": 1,
"8143": 1,
"1889": 1,
"2867": 1,
"1420": 1,
"4873": 1,
"2251": 1,
"9990": 1,
"5545": 1,
"5381": 1,
"5050": 1,
"9456": 1,
"5183": 1,
"1425": 1,
"7823": 1,
"9917": 1,
"8358": 1,
"3602": 1,
"9691": 1,
"22": 1,
"169": 1,
"4514": 1,
"3281": 1,
"8074": 1,
"9374": 1,
"7228": 1,
"8272": 1,
"3523": 1,
"4450": 1,
"7119": 1,
"816": 1,
"5577": 1,
"597": 1,
"762": 1,
"3926": 1,
"1633": 1,
"5362": 1,
"970": 1,
"661": 1,
"8618": 1,
"1045": 1,
"371": 1,
"6454": 1,
"8054": 1,
"519": 1,
"3168": 1,
"4691": 1,
"2953": 1,
"5687": 1,
"9430": 1,
"8856": 1,
"1231": 1,
"6844": 1,
"650": 1,
"8137": 1,
"3160": 1,
"6210": 1,
"5272": 1,
"4337": 1,
"2708": 1,
"7150": 1,
"8503": 1,
"794": 1,
"4733": 1,
"6361": 1,
"1377": 1,
"2849": 1,
"4525": 1,
"4052": 1,
"160": 1,
"2394": 1,
"9736": 1,
"7122": 1,
"1270": 1,

};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function() {
					installedCssChunks[chunkId] = 0;
				},
				function(e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
